/* eslint-disable @typescript-eslint/no-explicit-any */
import { Row, Col, Form } from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import variationService from 'service/variation';
import Button from 'components/base/Button';

interface CreateNonVariationProps {
  setFormData: any;
  formData: any;
}

const CreateNonVariation = ({
  setFormData,
  formData
}: CreateNonVariationProps) => {
  const { t, i18n } = useTranslation();

  const { register, control, setValue, getValues } = useForm();
  const [variationOption, setVariationOption] = useState<any>([]);

  //GET Variation to options
  useQuery(['GET_VARIATION'], async () => {
    await variationService
      .getList({ offset: 0, limit: 100, status: true })
      .then((res: any) => {
        const options = res?.variations?.map((option: any) => ({
          value: option.id,
          pid: option?.pid || 0,
          label: option.name?.[i18n?.language]
        }));
        setVariationOption(options);
      });
  });

  const onSubmit = () => {
    const data = getValues();
    const selectedVariation = variationOption.find(
      (item: any) => item.value === data.variation
    );
    const formDataItem = {
      var_value: data.name,
      variation: data?.label,
      variation_id: data?.variation,
      variation_pid: selectedVariation?.pid || 0
    };
    setFormData([...formData, formDataItem]);
  };

  return (
    <div>
      <Form noValidate>
        <Row className="mb-3 gx-3">
          <Col>
            <div className="react-select-container">
              <Controller
                name="variation"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <Form.Floating>
                    <Form.Select
                      {...field}
                      onChange={(e: any) => {
                        const selectedOption = variationOption.find(
                          (option: any) => option.value === e.target.value
                        );
                        if (selectedOption) {
                          setValue('name', '');
                          setValue('label', selectedOption?.label);
                        }

                        field.onChange(e);
                      }}
                    >
                      <option className="d-none" value=""></option>
                      {variationOption?.map((option: any) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>

                    <label htmlFor="floatingInputCustom">{t('category')}</label>
                  </Form.Floating>
                )}
              />
            </div>
          </Col>

          <Col className="d-flex gap-3">
            <Form.Floating className="md-4 flex-grow-1 bd-highlight">
              <Form.Control
                {...register('name')}
                type="text"
                placeholder={t('meanings')}
                onFocus={e => e.target.select()}
              />
              <label htmlFor="floatingInputCustom">{t('meanings')}</label>
            </Form.Floating>
            <Button
              className="bd-highlight"
              variant="primary"
              type="button"
              onClick={onSubmit}
            >
              {t('new')}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default CreateNonVariation;
